enum PaymentPresetTypes {
  Deposit = 'deposit',
  Full = 'full',
  None = 'none',
}

export default PaymentPresetTypes
